import reducer from "./contestLogsSlice"

export * from "./contestLogsSlice"

export default reducer
